import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
  InputDate,
} from '@/components/_common';
import { WorkOrderItemHistoryFormValues } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import {
  Checkbox,
  Col,
  Form,
  FormInstance,
  Radio,
  Row,
  Space,
  Tooltip,
} from 'antd';
import moment from 'moment';
import { FaInfoCircle } from 'react-icons/fa';

interface Props {
  form: FormInstance<WorkOrderItemHistoryFormValues>;
}

const months = new Array(6)
  .fill(0)
  .map((_, i) => moment().subtract(i, 'months').format('YYYY-MM-DD'))
  .reverse();

const WorkOrderItemHistoryFilter: React.FC<Props> = ({ form }) => {
  const fromDate = Form.useWatch('from', form);

  function handleValuesChange(fields: WorkOrderItemHistoryFormValues) {
    if (fields.monthDate) {
      form.setFieldsValue({
        from: moment(fields.monthDate).startOf('month'),
        to: moment(fields.monthDate).endOf('month'),
      });
    }
  }

  return (
    <Form form={form} onValuesChange={handleValuesChange}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <div style={{ marginBottom: 10 }}>
            <strong>Selecione um intervalo</strong>
          </div>
          <Row gutter={[16, 16]}>
            <Col flex={1}>
              <FloatingFormItem
                name="from"
                label="De"
                initialValue={moment().startOf('month')}
              >
                <InputDate />
              </FloatingFormItem>
            </Col>

            <Col flex={1}>
              <FloatingFormItem
                name="to"
                label="Até"
                initialValue={moment().endOf('month')}
              >
                <InputDate
                  disabled={!fromDate}
                  disabledDate={(date) => date.isSameOrBefore(fromDate)}
                />
              </FloatingFormItem>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <div style={{ marginBottom: 10 }}>
            <strong>Ou marque o mês desejado</strong>
          </div>
          <Form.Item name="monthDate" initialValue={months.at(-1)}>
            <Radio.Group
              optionType="button"
              buttonStyle="solid"
              options={months.map((month) => ({
                value: month,
                label: moment(month).format('MMM/YYYY').toUpperCase(),
              }))}
            />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Row align="middle" gutter={[16, 16]}>
            <Col span={24} md={12}>
              <FloatingFormItem
                name="companyId"
                label="Empresa"
                noStyle
                style={{ margin: 0 }}
              >
                <CompaniesInfiniteSelectField allowClear />
              </FloatingFormItem>
            </Col>

            <Col span={24} md={12}>
              <Form.Item name="hasCustomer" noStyle valuePropName="checked">
                <Checkbox>
                  <Space>
                    <span>Filtrar cliente</span>
                    <Tooltip title="Cliente relacionado no cadastro do orçamento">
                      <FaInfoCircle size={14} color="#38b3ca" />
                    </Tooltip>
                  </Space>
                </Checkbox>
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default WorkOrderItemHistoryFilter;
